/* eslint-disable no-unused-vars */
import { useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FormGroup, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { toast } from 'react-toastify';
import P from 'prop-types';
import { AutocompleteField } from '../FormFields';
import { PhoneMask, RemoveMask } from '../../utils/phoneMask';
import api from '../../service/api';

export default function CallModal({ open, setOpen, clientName, clientPhones, broker }) {
  const [values, setValues] = useState({
    extension: '',
  });

  const entering = () => {
    setValues({
      ...values,
      extension: '',
    });
  };

  const handleClose = () => {
    setOpen(false);
  };
  const submit = async (e) => {
    e.preventDefault();
    const valueDTO = {
      extension: RemoveMask(values.phone.name),
      user: broker.login,
    };
    try {
      const res = await api.post(`/vsphone`, valueDTO);
      if (res) {
        // next();
        handleClose();
      }
    } catch (error) {
      // console.log(error.response.data.mensagem);
      toast.error(error.response.data.mensagem, { position: 'top-center' });
    }
  };

  const handleChangeAutoComplete = (event, newValue, variable) => {
    if (newValue) {
      setValues({
        ...values,
        [variable]: newValue,
      });
    }
  };

  return (
    <div>
      <Dialog
        onEntering={entering}
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="sm">
        <DialogTitle id="form-dialog-title" style={{ backgroundColor: '#fc986a' }}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
            Ligar para {clientName}
            <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <form onSubmit={submit}>
          <DialogContent>
            <FormGroup>
              <AutocompleteField
                valueText={values.phone ? values.phone.name : ''}
                options={[
                  { id: 1, name: clientPhones[0] ? PhoneMask(clientPhones[0]) : '' },
                  { id: 2, name: clientPhones[1] ? PhoneMask(clientPhones[1]) : '' },
                ]}
                value={values.phone || null}
                varibleName="phone"
                onChange={handleChangeAutoComplete}
                label="Telefone de contato"
                required
              />
            </FormGroup>
            {/* <TextField
              autoFocus
              margin="dense"
              label="Fila"
              type="text"
              value={values.queue}
              fullWidth
              required
              onChange={(e) => setValues({ ...values, queue: e.target.value })}
            />
            <TextField
              autoFocus
              margin="dense"
              label="Motivo"
              type="text"
              value={values.reason}
              fullWidth
              required
              onChange={(e) => setValues({ ...values, reason: e.target.value })}
            /> */}
          </DialogContent>
          <DialogActions>
            <Button type="submit" color="primary">
              Ligar
            </Button>
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

CallModal.propTypes = {
  open: P.bool.isRequired,
  setOpen: P.func.isRequired,
  clientName: P.string,
  clientPhones: P.arrayOf(P.string),
  broker: P.objectOf(P.any).isRequired,
  // next: P.func.isRequired,
};

CallModal.defaultProps = {
  clientName: 'Cliente',
  clientPhones: ['', ''],
};
